import React, { useEffect, useState } from 'react'
import axios from "axios";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from 'react-router-dom';
//  cookie functions
import { withTranslation, useTranslation } from "react-i18next";
// import Redux
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import { RootState } from "../../store/reducers";
// svg icons
import IMAGES from "../../assets/images";

import './Invoice.scss'

import FreezScreen from "../../components/FreezScreen";
import Pending from '../../components/status-svg/Pending';
import Processing from '../../components/status-svg/Processing';
import Success from '../../components/status-svg/Success';
import Failed from '../../components/status-svg/Failed';
import Cancel from '../../components/status-svg/Cancel';
import { waiterService } from '../../services';
import Header from '../../components/Header/Header';
import InvoiceData from '../../components/InvoiceData/invoiceData';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useParams } from "react-router-dom";
import { erase } from '../../helper/cookieFunction';
import InvoiceMarkedPopup from '../../components/InvoiceMarkedPopup/InvoiceMarkedPopup';
import BookingSvg from "../../assets/images/Booking.svg"

function Invoice() {
  let navigate = useNavigate();
  const { invoiceData, langValue,token,stateUrlToken,invoiceMarkedpopup } = useSelector((state: RootState) => state.waiter);


  const { transaction } = invoiceData;
  // console.log("invoiceData", invoiceData)
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { id }:any = useParams();
  const [encryptId, setencryptId] = useState(null)

  const {
    langValueState,
    freezScreenState,
    alertMessageState,
    invoiceState,
    setInvoiceMarkedpopup,
    setLoginState
  } = bindActionCreators(actionCreators, dispatch);

  const handleGetInvoice = async () => {
    freezScreenState(true)
    try {
      let response = await axios.get(`${process.env.REACT_APP_API_URL}/booking/single/${encryptId}`,{
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      if (response.status == 200) {
        invoiceState(response.data.data);
        if (response.data.success === true) {
          alertMessageState({
            type: "success",
            show: true,
            message: response.data.message,
          });
        }
        freezScreenState(false)
      }
      else {
        freezScreenState(false)
        alertMessageState({
          type: "error",
          show: true,
          message: response.data.message,
        });
      }
  } catch (error) {
      console.error("Error:", error);
      alertMessageState({
        type: "error",
        show: true,
        message: "Server Error",
      });
  } finally {
      // freezScreenState(false);
  }
  }



  useEffect(() => {
    freezScreenState(true)
    setencryptId(id)
  }, [id]);
  useEffect(() => {
    if(encryptId){
      handleGetInvoice()
    }
  }, [encryptId]);


  const handleMarkAsCompleted = async () => {
    try {
    const response = await waiterService.invoiceCompleted(invoiceData?.id,token);
    console.log("response",response)
      if (response.status == 200) {
        if (response.data.success === true) {
          setInvoiceMarkedpopup(true)
          alertMessageState({
            type: "success",
            show: true,
            message: response.data.message,
          });
        } 
        freezScreenState(false)
      }
      else {
        freezScreenState(false)
        alertMessageState({
          type: "error",
          show: true,
          message: response?.data?.message,
        });
        navigate(`/login?token=${stateUrlToken}`)
        // erase(`bookingAgent_url_token_${stateUrlToken}`)
        invoiceState([]);
        // setLoginState("","")
      }
  } catch (error) {
      console.error("Error:", error);
  } finally {
      // freezScreenState(false);
  }
}


  return (
    <>
      <Grid id="invoiceSectionsParent" container justifyContent="center" className="vh-100" >
        <Grid className="centerColumn" item xs={12} md={6}>
          <Header userFor="InvoiceData" /> 

          <div className="InvoiceStatusParent d-flex py-3  align-items-center justify-content-center" >

          <img src={BookingSvg} alt="BookingSvg" height={100} />

            <div className='mx-3' >
             <h4 className="mb-2 familysora600">Valid Booking</h4>
              <h6 className='m-0 familysora300'>{invoiceData?.booking_date}</h6>
              <h6 className='m-0 familysora300'>Table for {invoiceData?.guests} guest</h6>

            </div>
          </div>
          <Grid container justifyContent="center" className="firstGrid px-2">
            {transaction?.status === "Direct" || transaction?.status == "Partial" ? (
              <>
                <InvoiceData invoiceData={invoiceData} transaction={transaction} />
              </>
            ) : (
              <>

                <InvoiceData invoiceData={invoiceData} transaction={transaction} />

              </>
            )}

          </Grid>
          {(transaction?.status !== "Cancelled"  && transaction?.status !== "Paid") && <div className='d-flex justify-content-center py-3 bottomInvoiceBtn px-3' >
            {invoiceData.transaction != null ? <Button className='w-100 py-3' onClick={()=>handleMarkAsCompleted()} > {t("Forms.Re-Check")} </Button> : <Button className='w-100 py-3' onClick={()=>handleMarkAsCompleted()}> {t("Forms.Re-Check")} </Button>}
          </div>}

         {/* {invoiceMarkedpopup && <InvoiceMarkedPopup/> }  */}


        </Grid>
      </Grid>
    </>)
}

export default withTranslation()(Invoice);